const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          company: "Nombre de la Empresa",
          phone: "Whatsapp (COD + NÚMERO)",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      conecthubEmbed: {
        title: "Conectar ConectHUB 360",
        webhookHelp:
          "Copie la URL del webhook y péguela en el flujo de ConectHUB / Meta cuando se solicite.",
        openEmbed: "Abrir flujo ConectHUB",
        embedRunning:
          "Complete el flujo en la ventana de ConectHUB. Al terminar, la conexión se actualizará sola.",
        close: "Cerrar",
        copied: "¡URL copiada!",
        copyFail: "No se pudo copiar.",
        payloadRecoveryTitle: "No se pudo guardar automáticamente",
        payloadRecoveryHelp:
          "ConectHUB devolvió los datos correctamente, pero el sistema no pudo guardarlos. Copie el JSON abajo y guárdelo en un archivo de texto para soporte o para reintentar después.",
        copyPayload: "Copiar JSON de respuesta",
        payloadCopied: "¡JSON copiado!",
        success: "¡Conexión WhatsApp Oficial actualizada!",
        errors: {
          masterConfig:
            "El administrador debe configurar el enlace público y el Account ID de ConectHUB en Configuración → Planes.",
          generic: "No se pudo iniciar el flujo.",
          save: "No se pudieron guardar los datos de Meta.",
          embed: "Error en el flujo de ConectHUB.",
          script: "No se pudo cargar el script de ConectHUB."
        }
      },
      conecthub360Picker: {
        title: "Elegir canal",
        subtitle: "Seleccione el canal que desea conectar:",
        whatsappOfficial: "WhatsApp Oficial",
        facebook: "Facebook",
        instagram: "Instagram",
        telegram: "Telegram",
        comingSoon: "PRÓXIMAMENTE",
        planNoWhatsappOfficial:
          "Su plan no incluye WhatsApp Oficial o WhatsApp para este flujo.",
        planNoFacebook: "Su plan no incluye Facebook.",
        planNoInstagram: "Su plan no incluye Instagram.",
        planNoConecthub360:
          "Su plan no incluye ConectHUB 360 para conectar Telegram aquí."
      },
      conecthubMeta: {
        titleFacebook: "Facebook (ConectHUB)",
        titleInstagram: "Instagram (ConectHUB)",
        titleTelegram: "Telegram (ConectHUB)",
        hubChannelNoticeTitle: "Integración con embed.js oficial",
        hubChannelNoticeBody:
          "Conect HUB 360 abre el popup en /connect/{canal}/{accountId} (p. ej. /connect/facebook/…), igual que el embed.js oficial. Use el webhook y el callback abajo cuando el hub los pida.",
        webhookHelp:
          "Use las URLs abajo en el flujo de ConectHUB cuando se soliciten. El webhook es el mismo endpoint Meta que la app ya usa para Facebook e Instagram nativos (POST /webhook).",
        webhookLabel: "Webhook (URL del backend)",
        callbackLabel: "URL de callback",
        telegramHelp:
          "Use el mismo Account ID y enlace público de ConectHUB 360 configurados en la empresa maestra (como en el panel en Enlace directo → Telegram). No hace falta variables nuevas en .env solo para conectar: se usa el embed oficial del hub.",
        telegramDirectLinkLabel: "Enlace directo Telegram (panel ConectHUB — Enlace directo)",
        telegramDirectLinkWithWebhookLabel:
          "Enlace directo con webhook (recomendado — doc. ConectHUB «Enlaces directos por canal»)",
        telegramDirectLinkWithWebhookHint:
          "Incluye ?embed=true&webhook_url=… para que el hub sepa dónde enviar los mensajes entrantes al conectar en el navegador. Use el segmento telegram: …/connect/telegram/{accountId}.",
        telegramInboundWebhookLabel: "Webhook inbound Telegram (mensajes recibidos)",
        telegramInboundWebhookHelp:
          "Configure esta URL en ConectHUB para que el hub envíe los mensajes recibidos a su sistema. No es el webhook Meta (Facebook/Instagram): use POST …/webhook/telegram-mtproto. La URL debe ser accesible en internet (BACKEND_URL pública); localhost no recibe llamadas del hub — use un túnel (ngrok, Cloudflare Tunnel) o un servidor en producción.",
        telegramWebhookOptional:
          "Defina BACKEND_URL con la URL pública del backend para generar el webhook inbound de Telegram. Sin eso, el hub no puede entregar mensajes a su sistema.",
        successFacebook: "¡Facebook conectado con éxito!",
        successInstagram: "¡Instagram conectado con éxito!",
        successTelegram: "¡Telegram conectado con éxito!",
        errors: {
          masterAccount:
            "Configure el Account ID de ConectHUB en la empresa maestra (Configuración → Planes).",
          backendUrl:
            "Defina BACKEND_URL en el servidor (URL pública del backend) para generar webhook y callback.",
          generic: "No se pudo iniciar el flujo.",
          save: "No se pudo guardar la conexión. Revise los datos devueltos por ConectHUB.",
          tokenShape:
            "La respuesta de ConectHUB no trae un token de usuario reconocido. Copie el JSON para soporte o revise los nombres de los campos (access_token, id de usuario).",
          popupBlocked: "Permita ventanas emergentes para este sitio y abra ConectHUB."
        }
      },
      telegramBot: {
        title: "Conectar Telegram Bot",
        instructions: "Para conectar Telegram, necesita un Bot Token.",
        instructionsDetail:
          "1. Abra Telegram y busque @BotFather\n2. Envíe /newbot y siga las instrucciones\n3. Copie el token generado y péguelo abajo",
        nameLabel: "Nombre de la conexión (opcional)",
        namePlaceholder: "Ej: Atención Telegram",
        tokenLabel: "Bot Token",
        tokenHelp: "Formato: 123456789:ABCDefGhIJKlmnOPQrstUVwxyz...",
        tokenRequired: "Informe el token del bot.",
        invalidToken: "Formato de token inválido. Use el token de @BotFather.",
        btnConnect: "Validar y Conectar",
        validating: "Validando token y configurando webhook...",
        success: "¡Telegram conectado con éxito!",
        successTitle: "¡Bot conectado!",
        done: "Concluir",
        cancel: "Cancelar",
        menuLabel: "Telegram Bot (@BotFather)",
        errors: {
          connectFail: "Error al conectar el bot de Telegram."
        }
      },
      telegramPersonal: {
        title: "Telegram — cuenta personal",
        menuLabel: "Telegram personal (MTProto)",
        help:
          "Conecte su cuenta real de Telegram (no es un bot). Los mensajes recibidos aparecerán en MultiFlow.",
        phoneLabel: "Número de teléfono",
        phoneHint: "Formato internacional con DDI, ej: +5518998020650",
        phoneRequired: "Informe el número de teléfono.",
        nameLabel: "Nombre de la conexión (opcional)",
        sendCode: "Enviar código",
        codeSent: "¡Código enviado! Revise Telegram.",
        codeLabel: "Código de verificación",
        codeRequired: "Informe el código recibido.",
        codeHelp: "Ingrese el código enviado a {{phone}} en Telegram.",
        verifyCode: "Confirmar código",
        need2fa: "Esta cuenta usa verificación en dos pasos (2FA).",
        passwordLabel: "Contraseña 2FA",
        passwordRequired: "Informe la contraseña de verificación en dos pasos.",
        passwordHelp: "Ingrese la contraseña 2FA de Telegram.",
        verifyPassword: "Confirmar contraseña",
        success: "¡Telegram personal conectado!",
        cancel: "Cancelar",
        close: "Cerrar",
        serverNotConfigured:
          "Servidor sin TELEGRAM_API_ID / TELEGRAM_API_HASH. Configúrelos en el .env del backend (my.telegram.org/apps).",
        errors: {
          sendCode: "Error al enviar código.",
          verifyCode: "Código inválido o expirado.",
          verifyPassword: "Contraseña 2FA inválida."
        }
      },
      login: {
        title: "Inicio de Sesión",
        welcome: "Bienvenido de nuevo",
        loginInstruction: "Introduce tus datos para acceder a tu cuenta",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
          button: "Ingresar",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        dueDate: {
          expiration: "Suscripción caducará en",
          days: "días!",
          day: "día!",
          expirationToday: "Su suscripción termina hoy!",
        },
        token: "Token",
      },
      dashboard: {
        title: "Dashboard",
        loadingMessage: "Los datos del Dashboard se cargarán pronto...",
        refreshing: "Actualizando datos...",
        pleaseWait: "Por favor espere",
        refresh: "Actualizar datos",
        filters: "Filtros",
        filter: "FILTRAR ",
        general: {
          title: "Información General",
        },
        overview: {
          title: "Visión General y Evaluaciones",
        },
        activity: {
          title: "Actividad por Período y Rendimiento",
          daily: "Actividad Diaria",
          perHour: "Actividad por Hora",
        },
        distribution: {
          title: "Distribución por Canal y Sector",
          byChannel: "Distribución por Canal",
          byQueue: "Distribución por Sector",
          channels: "canales",
          queues: "sectores",
        },
        hourly: {
          title: "Actividad por Hora",
          peak: "Pico",
          between: "Entre",
          and: "y",
        },
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Agentes",
          weeklyOverview: "Visión Semanal",
        },
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
          messages: "Mensajes",
        },
        total: "Total",
        noData: "Sin datos disponibles",
        cards: {
          inAttendance: "En Atención",
          waiting: "Esperando",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Mensajes Recibidos",
          totalSentMessages: "Mensajes Enviados",
          averageServiceTime: "Atención",
          averageWaitingTime: "Espera",
          status: "Estado (Actual)",
          activeTickets: "Tickets Activos",
          passiveTickets: "Tickets Pasivos",
          groups: "Grupos",
          totalTickets: "Total de Tickets",
        },
        users: {
          name: "Nombre",
          numberAppointments: "Cantidad de Atenciones",
          statusNow: "Actual",
          totalCallsUser: "Total de atenciones por usuario",
          totalAttendances: "Total de atenciones",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        licence: {
          available: "Disponíble hasta",
        },
        filters: {
          title: "Filtros",
          apply: "Filtrar",
          reset: "Limpiar Filtros",
          quickFilters: "Filtros Rápidos",
          customRange: "Período Personalizado",
          allTime: "Todo el Período",
          today: "Hoy",
          yesterday: "Ayer",
          last7days: "Últimos 7 días",
          thisWeek: "Esta semana",
          thisMonth: "Este mes",
          lastMonth: "Mes pasado",
          sections: "Visibilidad de Secciones",
          refreshInterval: "Intervalo de actualización:",
          refreshManual: "Manual",
          refresh5min: "5 minutos",
          refresh15min: "15 minutos",
          refresh30min: "30 minutos",
          until: "hasta",
          hideSection: "Ocultar sección",
          showAll: "Mostrar Todas",
          hideAll: "Ocultar Todas",
        },
        assessments: {
          totalCalls: "Total de Atenciones",
          callsWaitRating: "Atenciones esperando evaluación",
          callsWithoutRating: "Atenciones sin evaluación",
          ratedCalls: "Atenciones evaluadas",
          evaluationIndex: "Índice de evaluación",
          score: "Puntuación",
          prosecutors: "Promotores",
          neutral: "Neutrales",
          detractors: "Detractores",
          ratingTooltip: "de los tickets evaluados",
        },
        tickets: {
          overview: "Estado de los Tickets",
          timeline: "Timeline de Atenciones",
          created: "Tickets Creados",
          active: "Tickets activos actualmente",
          pending: "Tickets esperando atención",
          completed: "Atenciones completadas",
          demandActive: "Demanda activa",
          demandPassive: "Demanda pasiva",
          inAttendanceTooltip: "Tickets que están siendo atendidos en este momento",
          waitingTooltip: "Tickets que aún no han sido asignados a un agente",
          finalizedTooltip: "Tickets que han sido cerrados y resueltos",
          activeTicketsTooltip: "Tickets que fueron iniciados por la empresa",
          passiveTicketsTooltip: "Tickets que fueron iniciados por el cliente",
        },
        messages: {
          title: "Mensajes por Período",
          received: "Recibidos",
          sent: "Enviados",
          total: "Total",
          ratio: "Proporción",
        },
        attendants: {
          performance: "Ranking de Agentes",
          online: "En línea ahora",
        },
        topContacts: {
          title: "Ranking de Contactos",
          columns: {
            contact: "Contacto",
            tickets: "Tickets",
            queue: "Sector",
            time: "Tiempo",
          },
          noData: "Sin contactos para mostrar",
          tooltip: "Top 10 contactos con más tickets abiertos en el período",
        },
        actions: {
          filter: "Filtrar",
          refresh: "Actualizar",
          fullscreen: "Pantalla completa",
          exitFullscreen: "Salir de pantalla completa",
        },
        online: "En línea ahora",
        serviceTime: "Tiempo promedio de atención",
        waitingTime: "Tiempo promedio de espera en cola",
        newContacts: "Nuevos contactos en el período",
        fromLastMonth: "desde el mes pasado",
        newContactsTooltip: "Nuevos contactos registrados en el período seleccionado",
        activeAttendantsTooltip: "Número de agentes disponibles en línea",
        timeMetrics: "Métricas de Tiempo",
        firstResponseTooltip: "Tiempo promedio hasta la primera respuesta del agente",
        resolutionRateTooltip: "Porcentaje de tickets resueltos en relación al total",
        reopenedTicketsTooltip: "Tickets que fueron reabiertos después del cierre",
        avgTicketsPerDayTooltip: "Promedio diario de tickets en el período",
        firstResponseTime: "Primera Respuesta",
        sort: {
          ascending: "Ascendente",
          descending: "Descendente",
          orderBy: "Ordenar por",
          tickets: "Número de Tickets",
          rating: "Evaluación",
          waitTime: "Tiempo de Espera",
          serviceTime: "Tiempo de Atención",
        },
        ticketStatusFilterValues: {
          open: "Abierto",
          pending: "Pendiente",
          closed: "Cerrado",
          group: "Grupo",
          chatbot: "Chatbot",
          nps: "NPS",
          lgpd: "LGPD",
        },
      },
      whatsappStatus: {
        title: "Estado de WhatsApp",
        subtitle: "Crea y comparte tu estado en WhatsApp",
        selectAccount: "Seleccionar Cuenta de WhatsApp",
        selectAccountPlaceholder: "Cuenta de WhatsApp",
        uploadMedia: "Subir Medios",
        image: "Imagen",
        video: "Video",
        audio: "Audio",
        statusText: "Texto del Estado",
        statusTextPlaceholder: "Escribe tu estado aquí...",
        backgroundColor: "Color de Fondo",
        scheduleForLater: "Programar para después",
        date: "Fecha",
        time: "Hora",
        repeat: "Repetir",
        noRepeat: "Sin Repetición",
        daily: "Diario",
        weekly: "Semanal",
        monthly: "Mensual",
        endDate: "Fecha de Fin",
        scheduleStatus: "Programar Estado",
        sendStatus: "Enviar Estado",
        sending: "Enviando...",
        previousStatuses: "Estados Anteriores",
        republish: "Republicar",
        delete: "Eliminar",
        deleteTitle: "Eliminar estado",
        deleteMessage: "¿Eliminar este estado también en WhatsApp (celular)? Se quitará del historial del panel.",
        deleteHint: "Intenta eliminar el story en WhatsApp; puede fallar si expiró (24h) o es registro antiguo",
        sent: "Enviado",
        failed: "Fallido",
        scheduled: "Programado",
        pending: "Pendiente",
        cancelled: "Cancelado",
        noStatuses: "No se encontraron estados anteriores",
        preview: "Vista Previa del Estado",
        myStatus: "Mi Estado",
        justNow: "Ahora mismo",
        replyToStatus: "Responder al estado...",
        previewPlaceholder: "Tu estado aparecerá aquí",
        toasts: {
          success: "¡Estado enviado con éxito!",
          scheduled: "¡Estado programado con éxito!",
          republished: "¡Estado republicado con éxito!",
          deleted: "Registro eliminado del historial",
          deleteError: "Error al eliminar estado",
          error: "Error al enviar estado",
          selectWhatsapp: "Selecciona un WhatsApp",
          addContent: "Escribe un texto o selecciona un medio",
          fileTooLarge: "Archivo muy grande. Tamaño máximo:",
          noPermission: "No tienes permiso para acceder a esta página",
        },
      },
      reports: {
        title: "Reporte de Pesquisas Realizadas",
        operator: "Agente",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Relatorios",
        calls: "Atenciones",
        search: "Pesquisas",
        durationCalls: "Duración de la atención",
        grupoSessions: "Atención en grupos grupos",
        startDate: "Fecha de inicio",
        endDate: "Fecha de finalización",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atención",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
          exportExcel: "Descargar Excel",
        },
        kanbanLane: "Kanban",
        kanbanLaneAll: "Todas las columnas",
        groupTicketsReports: {
          timezone: "America/Monterrey",
          msgToast: "Generando relatorio compactado, por favor espere.",
          errorToast: "Erro ao generar relatorio",
          back: "Volver",
          groupServiceReport: "Relatorio de Atención en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha Ultima Actualización",
          agent: "Agente",
          agentClosed: "Agente(cerró)",
          waitingAssistance: "Esperando atención",
          process: "En proceso",
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidade",
          percentage: "porcentaje",
          title: "Relatorio de Pesquisas Realizadas",
          activeSearch: "Pesquisa activa",
          inactiveSearch: "Pesquisa inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Generando relatorio compactado, por favor espere.",
          title: "Relatorio de Duración de la Atención",
          startService: "Início de la Atención",
          lastUpdated: "Última actualización",
          lastAgent: "Último agente",
          durationFinished: "Duración después de finalizado",
        },
        ticketDuration: {
          title: "Relatorio de Duración de Atención",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Generando relatorio compactado, por favor aguarde.",
          title: "Relatrio de Atención",
        },
        exportExcel: {
          title: "Reportes de Atención",
          startDate: "Fecha inicial",
          endDate: "Fecha final",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            contact: "Contacto",
            user: "Usuario",
            queue: "Fila",
            kanban: "Kanban",
            status: "Estado",
            lastMessage: "Último Mensaje",
            openDate: "Fecha Apertura",
            openTime: "Hora Apertura",
            closeDate: "Fecha Cierre",
            closeTime: "Hora Cierre",
            supportTime: "Tiempo de Atención",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relación de Atenciones Realizadas",
          exportTitle: "Relación de Atenciones en Grupos Realizadas",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas",
      },
      contactImportWpModal: {
        title: "Exportar Contactos para Excel",
        buttons: {
          downloadModel: "Download - modelo de excel para importación",
          closed: "Cerrar",
          import: "Seleccione el archivo de excel para importar los Contactos",
        },
      },
      connections: {
        title: "Conexiones",
        waitConnection: "Espere... Las conexiones serán reiniciadas!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Soporte",
        newConnection: "Nueva Conexión",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecta tus canales de atención para recibir mensajes e iniciar conversaciones con tus clientes.",
        client: "Cliente",
        connectedConnections: "Conexiones conectadas",
        disconnectedConnections: "Conexiones desconectadas",
        totalConnections: "Total de conexiones",
        total: "Total",
        connections: " Conexiones:",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
          closedimported:
            "Estamos cerrando los tickets importados, por favor espere.",
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage:
            "¿Seguro? Todos los tickets importados seran cerrados.",
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          closedImported: "Cerrar todos los tickets Importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes del WhatsApp",
          newQr: "Nuevo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Fecha del mensaje",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp",
          receiveComments: "Recibir Comentarios",
        },
        receiveComments: {
          enabled: "Recepción de comentarios habilitada",
          disabled: "Recepción de comentarios deshabilitada",
          tooltip: {
            enabled: "Los comentarios se están recibiendo. Haga clic para deshabilitar.",
            disabled: "Los comentarios no se están recibiendo. Haga clic para habilitar.",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Servicio existente",
        },
        form: {
          message: "Hay un ticket abierto para este contacto:",
          user: "Agente",
          queue: "Fila",
          messageWait: "Este contacto ya está en espera.",
        },
        reusedTicketToast:
          "Ya existe un ticket para este contacto en esta conexión. Abriendo el ticket…",
      },
      showTicketLogModal: {
        title: {
          header: "Historico",
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: "iniciou la atención.",
          access: "accesó el ticket.",
          transfered: "transferió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "regresó a la fila.",
          closed: "cerró el ticket",
          reopen: "abrió el ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        tabs: {
          general: "Geral",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario de trabajo",
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del celular",
          importOldMessages: "Fecha de inicio",
          importRecentMessages: "Fecha Final",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de la importación",
          name: "Nombre",
          queueRedirection: "Redirección de Fila",
          queueRedirectionDesc:
            "Seleccione una fila para los contactos que no tienen una fila para redirigir",
          default: "Por Defecto",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redireccionar a la fila",
          importAlert:
            "ATENCIÓN: Guardando, su conexión será cerrada, usted tendrá que volver a leer el QR Code para importar los mensajes",
          groupAsTicket: "Grupos como Ticket",
          timeCreateNewTicket: "Iniciar un nuevo ticket en *n* minutos",
          maxUseBotQueues:
            "Cantidad máxima de veces que el chatbot va a ser enviado",
          timeUseBotQueues: "Tiempo en minutos para nuevo envío del chatbot",
          expiresTicket: "Cerrar chats abiertos após *n* horas",
          expiresTicketNPS:
            "Cerrar chats aguardando la evaluacion luego de x minutos",
          maxUseBotQueuesNPS:
            "Cantidad máxima de veces que la evaluación será enviada",
          closeLastMessageOptions1: "Del Agente/Cliente",
          closeLastMessageOptions2: "Del Agente",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Link para políticas de privacidad",
          lgpdMessage: "Mensaje inicial de LPD",
          lgpdDeletedMessages: "Ofuscar mensaje borrada por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación - Rango de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage:
            "Tiempo em minutos para el envío del aviso de inactividad",
          whenExpiresTicket:
            "Cerrar chats abiertos cuando el último mensaje sea",
          expiresInactiveMessage: "Mensaje al cerrar por inactividade",
          prompt: "Prompt",
          triggerIntegrationOnClose:
            "Integración de activadores al cerrar un ticket",
          triggerIntegrationOnCloseMode: "Acción",
          enableIntegration: "Activadore Integración",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Activado",
          disabled: "Desactivado",
          triggerIntegrationOnCloseModeAsk: "Preguntar",
          triggerIntegrationOnCloseModeTrigger: "Disparar",
          minutes: "minutos",
        },
        success: "WhatsApp guardado satisfactoriamente.",
        errorSendQueue:
          "Además del tiempo debes seleccinar una fila para redirecionar. Se necesitan los dos campos.",
        errorExpiresNPS:
          "Es necesario llenar el tiempo para la evaluación para el NPS.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
        modalTitle: "Pasos para acceder",
        step1: "Abre WhatsApp en tu móvil",
        step2:
          "Toca Más opciones (Android) o Ajustes (iPhone)",
        step3:
          "Selecciona \"Dispositivos vinculados\" y luego \"Vincular un dispositivo\"",
        step4: "Escanea este código QR para confirmar",
        hintBelowQr:
          "Apunta la cámara del móvil a esta pantalla para capturar el código",
        remainingTime: "Tiempo restante",
        expireSoon:
          "El código expira en segundos. Si no puedes escanearlo, solicita un nuevo QR.",
        expiredHint:
          "Este código puede haber expirado. Solicita un nuevo QR CODE en la lista de conexiones.",
        waiting: "Generando código...",
        close: "Cerrar",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        conversationFlows: "La conversación fluye",
        addFlow: "Agregar Flujo",
        editFlow: "Editar Flujo ",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          blockContact: "¿Estás seguro que quieres bloquear este contacto?",
          unblockContact:
            "¿Estás seguro que quieres desbloquear este contacto?",
          importMessage: "¿Quieres importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport:
            "¿Quieres importar todas las conversaciones del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
          lastMessage: "Ultimo Mensaje",
        },
        menu: {
          importYourPhone: "Importar del celular por default",
          importToExcel: "Importar / Exportar del Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Reenviada",
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes del Historico",
          voiceKey: "Llave de la API de la Voz",
          voiceRegion: "Región de la Voz",
        },
        success: "Prompt guardado",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Fila",
          max_tokens: "Máximo Tokens Respuestas",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
          chatBotContact: "Desactivar chatbot para este contacto",
          termsLGDP: "Términos P.P. aceptados en:",
          allTicket: "Visualizar tickets sin fila",
          allowGroup: "Permitir grupos",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
        walletLinked: "¡Contacto vinculado a su billetera exitosamente!",
        walletError: "El usuario no tiene colas asociadas",
        saveFirst: "El contacto debe guardarse primero",
      },
      wallets: {
        title: "Billeteras de Contactos",
        searchPlaceholder: "Buscar contactos...",
        filterByUser: "Filtrar por Usuario",
        allUsers: "Todos los usuarios",
        contact: "Contacto",
        user: "Usuario",
        queue: "Cola",
        phone: "Teléfono",
        email: "Email",
        actions: "Acciones",
        editWallet: "Editar Billetera",
        selectUser: "Seleccionar Usuario",
        selectQueue: "Seleccionar Cola",
        selectUserAndQueue: "Seleccione un usuario y una cola",
        cancel: "Cancelar",
        save: "Guardar",
        confirmDeleteTitle: "Confirmar Eliminación",
        confirmDeleteMessage:
          "¿Está seguro de que desea eliminar este contacto de la billetera?",
        deleteSuccess: "¡Contacto eliminado de la billetera exitosamente!",
        updateSuccess: "¡Billetera actualizada exitosamente!",
        exportExcel: "Exportar a Excel",
        exportSuccess: "¡Planilla exportada exitosamente!",
      },
      queueModal: {
        title: {
          queueData: "Datos de la fila",
          text: "Horarios de atención",
          add: "Agregar fila",
          edit: "Editar fila",
          confirmationDelete:
            "¿Está seguro? Todas las opciones integradas también se eliminarán.",
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la fila (Bot)",
          rotate: "Rotativo",
          timeRotate: "Tiempo de Rotación",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de cierre",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Listado de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menu",
          queueTypeButton: "Botón",
          queueTypeList: "Lista",
          buttonTextLabel: "Texto del botón",
          buttonTextPlaceholder: "Ej.: Ventas, Soporte, Salir",
          buttonTextHelper: "En WhatsApp el texto del botón tiene límite de 20 caracteres.",
          listOptionLabel: "Texto de la opción de la lista",
          listOptionPlaceholder: "Escriba el texto de esta opción",
          message: "Mensaje de respuesta",
          queue: "Fila para transferencia",
          integration: "Integración",
          file: "Listado de archivos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Editar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue las opciones para construir un chatbot",
          toolTip:
            "Si solo hay una opción, se elegirá automáticamente, lo que hará que el bot responda con el mensaje de la opción y avance.",
          selectOption: "Seleccione una opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Fila",
          integration: "Integranción",
          file: "Archivo",
          toolTipMessageTitle:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          toolTipMessageContent:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Fila",
          selectIntegration: "Seleccione um Integración",
          addOptions: "Agregar opciones",
        },
        serviceHours: {
          dayWeek: "Día",
          startTimeA: "Hora de Inicio",
          endTimeA: "Hora del término",
          startTimeB: "Hora de Inicio",
          endTimeB: "Hora del término",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sabado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar la conversación",
          typebotUnknownMessage: "Mensaje de opción invalida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración testada con éxito!",
          addSuccess: "¡Integración agregada con éxito!",
          editSuccess: "¡Integración editada con éxito!",
        },
      },
      userModal: {
        warning:
          "Para importar los mensajes por favor vuelva a leer el QRCode.",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar Imagen",
          removeImage: "Excluir Imagen",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio del Horario",
          endWork: "Final del Horario",
          whatsapp: "Conexión Defautl",
          allTicketEnable: "Activado",
          allTicketDisable: "Desactivado",
          allTicket: "Visualizar mensajes sin fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menu Estándar",
          defaultTheme: "Tema Estándar",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver historicos",
          allHistoricEnabled: "Activado",
          allHistoricDisabled: "Desactivado",
          allUserChat: "Ver conversación de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          showDashboard: "Ver Dashboard",
          allowWhatsappStatus: "Publicar Estado",
          enabled: "Habilitado",
          disabled: "Deshabilitado",
        },
        tabs: {
          general: "General",
          permissions: "Permissos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "La Empresa fue guardada satisfactoriamente.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Programa",
          edit: "Editar Programa",
          view: "Detalles del agendamiento",
          message: "Mensaje",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Programa guardado satisfactoriamente.",
      },
      tagModal: {
        title: {
          add: "Nueva Tag",
          edit: "Editar Tag",
          addKanban: "Nueva Lane",
          backToKanban: "VOLVER A KANBAN",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nombre",
          color: "Color",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Tag guardada satisfactoriamente.",
        successKanban: "Lane guardada satisfactoriamente.",
      },
      fileModal: {
        title: {
          add: "Agregar menú de evaluación",
          edit: "Editar menú de evaluación",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre",
          message: "Mensaje de Evaluación",
          options: "Opciones de Evaluación",
          extraName: "Nombre de la opción",
          extraValue: "Valor de la opción",
        },
        success: "Evaluación guardada satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTRE Y SUELTE LOS ARCHIVOS EN EL CAMPO ⬇️",
          titleFileList: "Listado de archivo(s)",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "¿Quieres cerrar todos los tickets?",
        yes: "SI",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolvAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        messageHidden: "Mensaje oculto",
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAllTicketsDescription: "¿Está seguro que desea cerrar todos los tickets de esta pestaña?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SI",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos",
        },
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por usuarios",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Entradas por página",
          filtersApplied: "Filtros Aplicados",
          clearFilters: "Limpiar Filtros",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Regresar a la Fila",
          scredule: "Programar",
          deleteTicket: "Borrar Ticket",
        },
        closedTicket: {
          closedMessage: "Cerrar CON un mensaje de despedida",
          closedNotMessage: "Cerrar SIN un mensaje de despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Seleccione una fila",
        fieldWhatsapp: "Seleccione un whatsapp",
        noOptions: "No se encontraron usuarios con ese nombre",
        msgTransfer:
          "Observación - los mensajes internos, no serán visualizados por el cliente.",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsList: {
        called: "Entradas",
        today: "Hoy",
        missedCall: "Llamada de voz/vídeo perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Trabajando en",
        groupingHeader: "Grupos",
        closedHeader: "Resueltos",
        noTicketsTitle: "¡Nada acá!",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        noQueue: "Sin Fila",
        sortUnreadFirst: "No leídos primero",
        sortByDate: "Por fecha",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar tag",
        },
        actions: {
          newTicket: "Nuevo ticket",
          search: "Buscar",
          showMyTickets: "Mostrar mis tickets",
          showAll: "Mostrar todos",
          openFilters: "Abrir Filtros",
          closeFilters: "Cerrar Filtros",
          closeAllTickets: "Cerrar todos los tickets",
          searchButton: "Buscar",
          clearSearch: "Limpiar Búsqueda",
          searchInMessages: "Buscar en el contenido de los mensajes",
          appliedFilters: "Filtros Aplicados",
          clearAllFilters: "Limpiar todos los filtros",
          clearFilters: "Limpiar Filtros",
          clear: "Limpiar",
          newAttendance: "Nueva Atención",
          resolved: "Resueltos",
          newestFirst: "Más recientes primero",
          oldestFirst: "Más antiguos primero",
          selectTicket: "Seleccionar Ticket",
          attendances: "Atenciones",
        },
        ticketMessageSearchModal: {
          title: "Mensajes en este ticket",
          resultsSuffix: "resultado(s) en este ticket",
          empty: "No se encontraron mensajes en este ticket.",
          close: "Cerrar",
          you: "Tú",
          contactUnknown: "Contacto no identificado",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Agregar",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Buscar contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Panel de Asistencia",
          tickets: "Inbox",
          quickMessages: "Respuestas Rápidas",
          contacts: "Contactos",
          wallets: "Billeteras",
          queues: "Filas",
          tags: "Tags",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          settings: "Configuración",
          ratings: "Regist. Evaluaciones",
          helps: "Ayuda",
          apisSubmenu: "APIs",
          messagesAPI: "API",
          apiOficialDocs: "API Oficial",
          testInteractive: "Probar botones/lista",
          schedules: "Programa",
          campaigns: "Campañas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financiero",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Admin conexiones",
          automations: "Automatizaciones",
          auditLogs: "Logs de Auditoría",
          groupManagement: "Gestión de Grupos",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y te seguiré apoyando.",
            virtualAssistant: "Asistente Virtual",
            token:
              "Token inválido, favor comunicarse con el administrador de la plataforma.",
          },
          message: {
            location: "Localización",
            contact: "Contacto",
          },
          notRegister: "No hay registros",
          refresh: "Atuaclizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "es-Mx": "Español",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID usuario/agente",
          queueId: "ID Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        API: {
          title: "Documentación para envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Midia",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1:
              "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. <br />Para registrarse, acceda al menú 'Conexiones', haga clic en el botón de edición de la conexión e inserte el token en el campo correspondiente.",
            comments2:
              "El número de envío no debe tener máscara ni caracteres especiales y debe constar de:",
            codeCountry: "Código del País",
            code: "Código del Estado",
            number: "Numero",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes con archivos:",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "No hay",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir. ¿Continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atajo agregado satisfactoriamente.",
          deleted: "Atajo excluido satisfactoriamente.",
        },
        dialog: {
          title: "Mensaje Rápida",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          general: "General",
          geral: "Global",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listado de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Listado",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listados",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
          importMessage: "¿Quieres importar esta plantilla? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      kanban: {
        title: "Kanban",
        laneTicketCountTooltip: "Tickets en esta columna: {{count}}",
        laneTicketCountAria: "{{count}} tickets en esta columna",
        laneTicketCountFilteredTooltip: "Mostrando {{filtered}} de {{total}} tickets en esta columna",
        laneTicketCountFilteredAria: "{{filtered}} de {{total}} tickets en esta columna",
        laneSearchTooltip: "Filtrar por nombre o número del contacto",
        laneSearchAria: "Buscar contacto en esta columna",
        laneSearchPlaceholder: "Nombre o número del contacto",
        laneSearchClearAria: "Limpiar búsqueda",
        laneSearchNoResults: "Ningún contacto encontrado en esta columna",
        removeAssignedValue: "Quitar valor asignado",
        filterByUser: "Filtrar por Usuario",
        filterByConnection: "Filtrar por Conexión",
        filterAll: "Todos",
        showClosed: "Ver cerrados",
        ticketClosed: "Cerrado",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Admin",
          tags: "Lanes",
        },
        showingCardsPartial: "Mostrando {{visible}} de {{total}} tarjetas (cargue más para ver el resto).",
        loadMoreCards: "Cargar más tarjetas",
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Listados",
          listContacts: "Listados de contatos",
          settings: "Configuraciones",
        },
        settings: {
          randomInterval: "Intervalo de disparo aleatorio",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de envío más grande",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listado de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Listado de Contactos",
          option: "Ninguna",
          disabled: "Activada",
          enabled: "Desactivada",
          status: "Status",
          scheduledAt: "Programa",
          completedAt: "Finalizada",
          confirmation: "Confirmación",
          actions: "Acciones",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Visualizar",
          help: "Use variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del Mensaje",
            whatsapp: "Conexión",
            status: "Status",
            scheduledAt: "Programa",
            confirmation: "Confirmación",
            contactList: "Listado de Contacto",
            tagList: "Tags",
            statusTicket: "Status del Ticket",
            openTicketStatus: "Abierto",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Activado",
            disabledOpenTicket: "Desactivado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro excluido",
        },
      },
      campaignReport: {
        title: "Reporte de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Proceso",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregadas",
        connection: "Conexión",
        contactLists: "Listado de Contactos",
        schedule: "Programados",
        conclusion: "Conclusión",
      },
      announcements: {
        title: "Boletines",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Boletin",
          contactLists: "Listados de Boletines",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Status",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Boletin",
          add: "Nuevo Boletin",
          update: "Editar Boletin",
          readonly: "Solo visualizar",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Status",
            high: "Alta",
            medium: "Mediana",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          deleted: "Registro excluido",
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          orderQueue: "Orden de la fila (bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar fila",
        },
        toasts: {
          success: "Fila guardada",
          deleted: "Fila excluida",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa fila seguirán existiendo, pero ya no tendrán ninguna fila asignada.",
        },
      },
      queue: {
        queueData: "Datos",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas solo para lectura",
        withoutQueue: "Sin cola",
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Ultima actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Se eliminarán las filas y conexiones enlazadas",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Status",
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          startWork: "Inicio del trabajo",
          endWork: "Final de trabajo",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre del Plan",
          numberQueues: "Filas",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programa",
          createdAt: "F.Creación",
          dueDate: "Caducidad",
          lastLogin: "Ult. Login",
          folderSize: " Tamaño de carpeta ",
          totalFiles: "  Archivos totales",
          lastUpdate: "Última actualización",
          actions: "Acciones",
          money: "MXN",
          yes: "Si",
          no: "No",
          document: "CURP/RFC",
          recurrence: "Recurencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
        },
        buttons: {
          add: "Agregar empresa",
        },
        toasts: {
          deleted: "Empresa excluida satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todas las informaciones de la empresa serán eliminadas. Los tickets abiertos de este usuário serán movidos a la fila.",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Programas",
          groupManagement: "Gestión de Grupos",
          whatsappMeow: "WhatsMeow (WuzAPI)",
          conecthub360: "Conecthub 360",
          useTelegram: "Telegram",
          telegramSetupTitle: "Telegram — configuración del servidor (usuario master)",
          telegramSetupBody:
            "1) Cree una app en my.telegram.org/apps y configure en el .env del backend: TELEGRAM_API_ID y TELEGRAM_API_HASH (válido para toda la instalación). Reinicie el backend (PM2) después de guardar.\n2) En este plan, habilite «Telegram» para permitir conexiones.\n3) Bot (@BotFather): cada bot usa su propio token — no necesita las variables anteriores.\n4) Cuenta personal (MTProto): Conexiones → Telegram personal — usa las variables del .env.",
          telegramPlanHint: "Habilita Bot @BotFather y cuenta personal (MTProto) en este plan.",
          conecthubOpen: "Abrir ConectHUB",
          conecthubPublicLink: "Enlace público de ConectHUB 360",
          conecthubPublicLinkSave: "Guardar enlace",
          conecthubPublicLinkToastOk: "Configuración ConectHUB guardada en la empresa maestra.",
          conecthubPublicLinkToastErr: "No se pudo guardar la configuración de ConectHUB.",
          conecthubAccountId: "Account ID (ConectHUB)",
          conecthubMessagingApiKey: "API Key (mensajería ConectHUB)",
          conecthubMessagingApiKeyHint:
            "Clave para la API de mensajes del hub (cabecera X-API-Key). Solo empresa maestra.",
          enabled: "Activada",
          disabled: "Desactivada",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Si",
          no: "No",
          money: "MXN",
          phraseListFlow: "Flujo de campaña (listas)",
          conversationFlow: "Flujo de conversación (flowbuilder)",
          followUpFlow: "Follow UP (plantillas)",
          phraseListFlowShort: "Fl. campaña",
          conversationFlowShort: "Fl. conversación",
          followUpFlowShort: "Follow UP",
        },
      },
      helps: {
        title: "Ayuda",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
        },
      },
      schedules: {
        title: "Programas",
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Todo el Día",
        week: "Semana",
        work_week: "Programaciones",
        day: "Día",
        month: "Mes",
        previous: "Anterior",
        next: "Siguiente",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        today: "Hoy",
        agenda: "Agenda",
        noEventsInRange: "No hay eventos en este período.",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir este Programa?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          status: "Status",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Programa",
        },
        toasts: {
          deleted: "Programa eliminado satisfactoriamente.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ AGREGAR COLUMMAS",
        search: "BUSCAR",
        seeTicket: "VER BILLETE",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Tag?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Tag",
        },
        toasts: {
          deleted: "Tag eliminada satisfactoriamente.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Abierto(s)",
        backToKanban: "VOLVER A KANBAN",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Lane?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lane",
        },
        toasts: {
          deleted: "Lane eliminada satisfactoriamente.",
        },
      },
      files: {
        title: "Listado de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "Listado borrado satisfactoriamente!",
          deletedAll: "Todos los listados fueron borrados satisfactoriamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Borrar Todos",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteAllTitle: "Borrar Todos",
          deleteMessage: "Estás seguro de borrar este listado?",
          deleteAllMessage: "Estás seguro de borrar todos los listado?",
        },
      },
      holidays: {
        title: "Días Festivos Recurrentes",
        infoText: "Días festivos recurrentes - válidos para cualquier año. Cuando se reciba un mensaje en un día festivo activo, la descripción del festivo se enviará automáticamente.",
        table: {
          dayMonth: "Día/Mes",
          description: "Descripción",
          status: "Estado",
          statusActive: "Activo",
          statusInactive: "Inactivo",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar",
        },
        modal: {
          createTitle: "Nuevo Día Festivo",
          editTitle: "Editar Día Festivo",
          month: "Mes",
          day: "Día",
          description: "Descripción del Día Festivo",
          descriptionPlaceholder: "Ej: Día de la Independencia",
          isActive: "Día Festivo Activo",
          save: "Guardar",
          create: "Crear",
          cancel: "Cancelar",
          infoText: "Este día festivo será válido para cualquier año (2025, 2026, 2027...)",
        },
        confirmationModal: {
          deleteTitle: "Eliminar Día Festivo",
          deleteMessage: "¿Realmente desea eliminar el día festivo",
        },
        toasts: {
          created: "¡Día festivo creado con éxito!",
          updated: "¡Día festivo actualizado con éxito!",
          deleted: "¡Día festivo eliminado con éxito!",
        },
        empty: "No hay días festivos registrados",
      },
      groupManagement: {
        title: "Gestión de Grupos WhatsApp",
        selectConnection: "Seleccione la conexión",
        listGroups: "Listar grupos",
        listGroupsDescription: "Ver todos los grupos de la conexión",
        createGroup: "Crear grupo",
        createGroupDescription: "Crear nuevo grupo y añadir participantes",
        broadcast: "Envío masivo",
        broadcastDescription: "Enviar mensaje a varios grupos",
        editGroup: "Editar grupo",
        editGroupDescription: "Cambiar datos y participantes de grupos en los que eres admin",
        editGroupAdminOnlyHint: "Solo se listan los grupos en los que este número es administrador.",
        editGroupListHint: "Se listan los grupos de esta conexión. Solo se pueden editar los grupos en los que este número es administrador.",
        tabGroupInfo: "Información del grupo",
        noAdminGroups: "Ningún grupo en el que seas administrador.",
        saveGroup: "Guardar cambios",
        groupUpdated: "Grupo actualizado correctamente.",
        editGroupParticipants: "Añadir o quitar participantes",
        noConnections: "Ninguna conexión disponible",
        noConnectionsTitle: "Ninguna conexión con gestión de grupos",
        noConnectionsHint: "Conecte un WhatsApp (Baileys o WhatsMeow) para usar la gestión de grupos.",
        back: "Volver",
        groupName: "Nombre del grupo",
        groupNamePlaceholder: "Ej: Mi Grupo",
        groupDescription: "Descripción del grupo",
        groupDescriptionPlaceholder: "Texto que aparece en la información del grupo (opcional)",
        groupCoverPhoto: "Foto de portada",
        addCoverPhoto: "Haga clic o arrastre una imagen",
        changeCoverPhoto: "Haga clic para cambiar la foto de portada",
        currentCover: "Portada actual",
        removeCover: "Quitar portada",
        coverMustBeImage: "Seleccione un archivo de imagen (JPG, PNG, etc.).",
        participantsCount: "Participantes",
        actions: "Acciones",
        seeParticipants: "Ver participantes",
        leaveGroup: "Salir del grupo",
        leaveGroupConfirm: "¿Salir del grupo \"{{name}}\"? Dejará de recibir mensajes.",
        leaveGroupOthersRemain: "Los demás participantes seguirán en el grupo. En WhatsApp no se puede eliminar el grupo para todos.",
        deleteGroup: "Eliminar grupo",
        deleteGroupTitle: "Eliminar grupo",
        deleteGroupConfirmMessage: "Para confirmar la eliminación del grupo \"{{name}}\", escriba ELIMINAR abajo.",
        deleteGroupTypePlaceholder: "Escriba ELIMINAR",
        deleteGroupConfirmWord: "ELIMINAR",
        noGroups: "Ningún grupo encontrado.",
        participants: "Participantes",
        nameRequired: "Indique el nombre del grupo.",
        groupCreated: "Grupo creado correctamente.",
        create: "Crear",
        participantName: "Nombre",
        participantNumber: "Número",
        admin: "Admin",
        noParticipants: "Ningún participante.",
        addParticipant: "Añadir",
        removeParticipant: "Quitar participante",
        participantNumberRequired: "Indique el número del participante.",
        participantAdded: "Participante añadido.",
        participantRemoved: "Participante eliminado.",
        removeSelected: "Quitar seleccionados",
        participantsRemoved: "{{count}} participante(s) eliminado(s).",
        selectAtLeastOneParticipant: "Seleccione al menos un participante.",
        generateCampaign: "Generar campaña",
        listFromGroup: "Lista del Grupo",
        chooseCampaignType: "Elija el tipo de campaña",
        chooseCampaignTypeHint: "Se creará una lista en Campañas PRO con los contactos seleccionados. Luego abra la campaña deseada.",
        campaignPro: "Campaña PRO",
        campaignOfficial: "Campaña Oficial",
        creatingList: "Creando lista...",
        creatingListHint: "Añadiendo contactos a la lista. Espere.",
        exportCsv: "Exportar CSV",
        normalizingTitle: "Normalizando participantes",
        normalizingProgress: "Resolviendo nombres y números de contactos. Puede tardar hasta 1 minuto.",
        validatingContactCount: "Validando contacto {{current}} de {{total}}",
        importMapping: "Importar mapeo",
        importMappingTitle: "Mapeo LID → Nombre/Número",
        importMappingHint: "Pegue un CSV con columnas: lid;numero;nombre (una línea por participante). LID es el ID que aparece cuando el número no es conocido.",
        importMappingPlaceholder: "Ej.: 68899982856277;5511999999999;Juan Pérez",
        importMappingSuccess: "Mapeo importado: {{created}} nuevos, {{updated}} actualizados.",
        importMappingError: "Error al importar mapeo.",
        cancel: "Cancelar",
        selectGroupsToSend: "Seleccione los grupos para enviar el mensaje",
        selectAll: "Seleccionar todos",
        searchGroups: "Buscar por nombre",
        message: "Mensaje",
        sendBroadcast: "Enviar",
        attachMedia: "Adjuntar archivo",
        sendMedia: "Enviar archivo",
        mediaImage: "Imagen",
        mediaVideo: "Video",
        mediaAudio: "Audio",
        mediaDocument: "Documento",
        removeMedia: "Quitar archivo",
        messageCaptionHint: "Opcional: pie de foto para el archivo",
        messageOrMediaRequired: "Escriba el texto y/o adjunte un archivo (imagen, audio o PDF).",
        results: "Resultado por grupo",
        previewTitle: "Vista previa en tiempo real",
        previewEmpty: "Escriba su mensaje para ver la vista previa",
        leftGroup: "Has salido del grupo.",
        selectGroupsAndMessage: "Seleccione al menos un grupo y escriba el mensaje.",
        broadcastSent: "Enviado: {{count}} de {{total}} grupos.",
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        tabs: {
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda",
          companies: "Empresas",
        },
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            ask: "Preguntar",
            askGreetingConfirm: "¿Desea enviar el mensaje de bienvenida?",
            updating: "Actualizando...",
            creationCompanyUser: "Creación de Empresa/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Programación de Horario",
            queueManagement: "Gestión por Cola",
            companyManagement: "Gestión por Empresa",
            connectionManagement: "Gestión por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket:
              "Enviar mensaje de transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar mensajes de grupos",
            chatBotType: "Tipo de Bot",
            chatBotTypeText: "Texto",
            chatBotTypeButton: "Botones",
            chatBotTypeList: "Lista",
            userRandom: "Elegir agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp:
              "¿Informar que no se aceptan llamadas por WhatsApp?",
            sendSignMessage: "Permitir al agente elegir ENVIAR firma",
            sendGreetingMessageOneQueues:
              "Enviar saludo cuando haya solo una cola",
            sendQueuePosition: "Enviar mensaje con la posición en la fila",
            sendFarewellWaitingTicket:
              "Enviar mensaje de despedida al estar en espera",
            acceptAudioMessageContact:
              "¿Aceptar audios de todos los contactos?",
            enableLGPD: "Habilitar tratamiento de datos (LGPD)",
            requiredTag: "Etiqueta obligatoria para cerrar el ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir a otra cola",
            DirectTicketsToWallets:
              "Mover automáticamente al cliente a la cartera",
            showNotificationPending:
              "Mostrar notificación para tickets pendientes",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la fila",
            AcceptCallWhatsappMessage:
              "Mensaje para informar que no se aceptan llamadas",
            greetingAcceptedMessage: "Mensaje de saludo al aceptar el ticket",
            transferMessage:
              "Mensaje de transferencia - ${queue.name} = cola de destino",
          },
          LGPD: {
            title: "Politica de Privacidad",
            welcome: "Mensaje de bienvenida (PP)",
            linkLGPD: "Link de la política de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje borrada",
            alwaysConsent: "Requerir siempre el consentimiento",
            obfuscatePhoneUser: "Ofuscar número de telefono para usuarios",
            enabled: "Activado",
            disabled: "Desactivado",
          },
        },
      },
      messagesList: {
        messageFailed: "Error al enviar el mensaje.",
        scrollToBottom: "Ir al último mensaje",
        scrollToQuoted: "Ir al mensaje original",
        searchScrollNotFound:
          "No se pudo encontrar este mensaje en la conversación actual (historial muy antiguo o mensaje eliminado).",
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle:
            "¿Quieres dejar un mensaje de evaluación para el cliente?",
          dialogClosingTitle: "Finalizando la atención al cliente!",
          dialogRatingCancel: "Cerrar CON Mensaje de Despedida",
          dialogRatingSuccess: "Cerrar y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Cerrar SIN Mensaje de Despedida",
          ratingTitle: "Elegir menú de evaluación",
          notMessage: "No hay mensaje seleccionado",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Activar/Desactivar integración",
            logTicket: "Logs del Ticket",
            requiredTag:
              "Opps! Debes asignar una tag antes de cerrar el ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderOpen:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privada",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        searchScrollWrongTicket:
          "Este mensaje pertenece a otro ticket. Abra ese ticket para verlo en el historial.",
        searchScrollNoUuid:
          "No se pudo abrir el otro ticket (falta el identificador del ticket).",
        searchScrollStorageError:
          "No se pudo preparar la navegación. Compruebe que el almacenamiento del navegador esté permitido.",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Otras informaciones",
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          user: "Agente",
          greeting: "Saludos",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nº del Ticket",
          queue: "Sector",
          connection: "Conexión",
        },
      },
      ticketOptionsMenu: {
        schedule: "Programa",
        delete: "Borrar",
        transfer: "Transferir",
        closeTicket: "Cerrar ticket",
        conversar: "Conversar",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Cerrar sin despedida",
        acceptAudioMessage: "¿Aceptar audios del contacto?",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Agregue aqui la información",
        },
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Activar/Desactivar firma",
          privateMessage: "Activar/Desactivar mensaje privado",
          meet: "Enviar link para videollamada",
        },
        type: {
          imageVideo: "Fotos y videos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Link Jitsi Meet",
        },
        camera: {
          tabPhoto: "Foto",
          tabVideo: "Grabar video",
          preparing: "Preparando cámara…",
          startRecord: "Iniciar grabación",
          stopSend: "Detener y enviar",
          accessError: "No se pudo usar la cámara. Revise los permisos del navegador.",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        edit: "Editar",
        forward: "Enviar",
        toForward: "Enviar",
        talkTo: "Platicar Con",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
        officialApiNoEditDelete: "En la API Oficial de WhatsApp no se puede borrar ni editar mensajes. El cambio solo aplica en el sistema.",
        officialApiNoReactions:
          "Este canal (API Oficial de WhatsApp) no acepta reacciones con emoji.",
        channelNoReactions: "Este canal no acepta reacciones con emoji.",
        editModal: {
          title: "Editar mensaje",
          edited: "Editada",
          placeholder: "Escribe un mensaje",
          confirm: "Confirmar edición",
        },
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          action: "Acción",
        },
      },
      backendErrors: {
        ERR_OFFICIAL_NO_REACTIONS:
          "Este canal (API Oficial de WhatsApp) no acepta reacciones con emoji.",
        ERR_CHANNEL_NO_REACTIONS: "Este canal no acepta reacciones con emoji.",
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_SENDING_FACEBOOK_MSG:
          "Error al enviar mensaje por Facebook/Instagram. Intente de nuevo.",
        ERR_FACEBOOK_24H_WINDOW_CLOSED:
          "La ventana de 24 horas para responder ha terminado. Según las políticas de Meta, solo puede enviar mensajes dentro de las 24 horas posteriores al último mensaje del cliente. Espere a que el cliente vuelva a contactar para responder.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_CANNOT_DELETE_SUPER_ADMIN: "No se puede eliminar el usuario super administrador.",
        ERR_CANNOT_DELETE_MAIN_COMPANY: "No se puede eliminar la empresa principal del sistema.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una fila.",
        ERR_OUT_OF_HOURS: "¡Fuera del horario de oficina!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) y Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensaje"',
        fieldUserId: '"userId": ID de usuario o ""',
        fieldQueueId: '"queueId": ID de la Cola o ""',
        fieldSendSignature: '"sendSignature": Firmar mensaje - true/false',
        fieldCloseTicket: '"closeTicket": Cerrar el ticket - true/false',
        singMessage: "Firmar mensaje - true/false",
        closeTicket: "Cerrar el ticket - true/false",
        testSend: "la test del envio",
      },
      recurrenceSection: {
        title: "Recurrence",
        description:
          "You can choose to send the message recurrently and select the interval. If it is a one-time message, do not change anything in this section.",
        labelInterval: "Interval",
        intervalFilterValue: "Valor del filtro de intervalo",
        sendAsManyTimes: " Enviar tantas veces",
        shipNormallyOnNonbusinessDays: "Envío normal en días no laborables",
        sendOneBusinessDayBefore: "Enviar un día hábil antes",
        sendOneBusinessDayLater: "Enviar un día hábil después",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
      },
      servicePanel: {
        allowRealTime: "Panel de servicio",
      },
      financial: {
        invoices: "Facturas",
        details: "Detalles",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Colas",
        value: "Valor",
        expirationDate: "Fecha de Vencimiento",
        status: "Estado",
        action: "Acción",
      },
      statusFilter: {
        statusFilter: "Filtrar por estado",
      },
      momentsUser: {
        services: "Servicios:",
        pending: "Pendiente",
        noqueue: "SIN COLA",
      },
      campaignsPhrase: {
        searchCampaign: "Buscar campaña…",
        noSearchResults: "Ninguna campaña coincide con la búsqueda.",
        campaignsFlow: "Flujo de Campaña",
        campaigns: "Campaña",
        name: "Nombre",
        status: "Estado",
        newCampaignWithFlowByPhrase: "Nueva campaña con flujo por frase",
        editCampaignWithFlowByPhrase: "Editar campaña con flujo por frase",
        phraseTriggerName: "Nombre del disparador de frase",
        chooseAStream: "Elige una transmisión",
        whichPhraseTriggersTheFlow: " ¿Qué frase desencadena el flujo?",
        selectAConnection: "Seleccione una conexión",
        chooseAStream: "Elige una transmisión",
        status: " Estado",
        cancel: "CANCELAR",
        createCampaign: "CREAR CAMPAÑA ",
        saveCampaign: "Guardar Campaña",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Informe de Soporte",
          ticketId: "ID del Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Agente",
          date: "Fecha",
          lastMessage: "Último Mensaje",
          fullReport: "El informe completo está adjunto arriba",
          resolveAndTriggerIntegration: "Resolver y Disparar Integración",
          elementNotFoundForExport: "Elemento no encontrado para exportar.",
          reportFilename: "informe_soporte",
        },
      },
      chatList: {
        noMessages: "Sin mensajes",
        admin: "Administrador",
        member: "Miembro",
        searchChat: "Buscar chat...",
        createNewChat: "Crear nuevo chat",
        searchUser: "Buscar usuario...",
        noUserFound: "No se encontró usuario",
        noUserAvailable: "No hay usuarios disponibles",
        cancel: "Cancelar",
        details: "Detalles",
        deleteChat: "Eliminar Chat",
        deleteChatConfirm: "Esta acción no se puede deshacer, ¿confirmar?",
        detailsTitle: "Detalles",
        edit: "Editar",
        delete: "Eliminar",
        now: "ahora",
        minutesAgo: "hace {{count}}m",
        hoursAgo: "hace {{count}}h",
      },
      chatMessages: {
        deleted: "Este mensaje fue eliminado",
        deletedAdmin: "Mensaje eliminado - visible solo para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        cancel: "Cancelar",
        deleteMessage: "Eliminar Mensaje",
        deleteMessageConfirm:
          "¿Está seguro de que desea eliminar este mensaje?",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        doubleClickToReply: "Doble clic para responder",
        edited: "(editado)",
        forwarded: "(reenviado)",
        typeMessage: "Escribe un mensaje...",
        send: "Enviar",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        replyingTo: "Respondiendo a",
        clickToGoToOriginal: "Haga clic para ir al mensaje original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Eliminación",
        confirm: "Confirmar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        forward: "Reenviar",
        noChats: "No hay chats disponibles",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Nuevo",
        messages: "Mensajes",
        search: "Buscar...",
        noChats: "No se encontraron chats",
        noGroups: "No se encontraron grupos",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        error: "Error al cargar los datos",
        addGroupPhoto: "Agregar Foto de Grupo",
        changeGroupPhoto: "Cambiar Foto de Grupo",
        groupName: "Nombre del Grupo",
        groupDescription: "Descripción del Grupo",
        save: "Guardar",
        cancel: "Cancelar",
        createGroup: "Crear Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Eliminar Grupo",
        deleteGroupConfirm: "¿Está seguro de que desea eliminar este grupo?",
        edit: "Editar",
        delete: "Eliminar",
        details: "Detalles",
        groupDetails: "Detalles del Grupo",
        title: "Título",
        description: "Descripción",
        modal: {
          title: "Crear Grupo",
          editTitle: "Editar Grupo",
          save: "Guardar",
          cancel: "Cancelar",
          description: "Ingrese el nombre y la descripción del grupo.",
          name: "Group Name",
          create: "Create",
          edit: "Editar",
        },
      },
      whitelabel: {
        primaryColorLight: "Color Primario (Tema Claro)",
        primaryColorDark: "Color Primario (Tema Oscuro)",
        appName: "Nombre de la Aplicación",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Oscuro)",
        favicon: "Favicon",
        backgroundLight: "Imagen de Fondo (Tema Claro)",
        backgroundDark: "Imagen de Fondo (Tema Oscuro)",
        loginVideoYoutube: "Enlace del Vídeo de YouTube (Login)",
        loginVideoYoutubeHelper: "El vídeo aparecerá incrustado sobre el fondo de la página de login",
        loginVideoPosition: "Posición del vídeo en pantalla",
        videoPosition: {
          "top-left": "Superior izquierdo",
          "top-right": "Superior derecho",
          "bottom-left": "Inferior izquierdo",
          "bottom-right": "Inferior derecho",
        },
        preview: "Vista Previa",
        delete: "Eliminar",
        upload: "Subir",
        availableLanguages: "Idiomas Disponibles",
        atLeastOneLanguage: "Al menos un idioma debe estar habilitado",

        sections: {
          general: "Configuraciones Generales",
          generalDescription: "Configura el nombre y la información básica de la aplicación",
          colors: "Colores y Temas",
          colorsDescription: "Personaliza los colores primarios para los temas claro y oscuro",
          logos: "Logos e Imágenes",
          logosDescription: "Sube los logos e imágenes de fondo de la aplicación",
          languages: "Idiomas Disponibles",
          languagesDescription: "Selecciona qué idiomas estarán disponibles en el sistema"
        }
      },
    },
  },
};

export { messages };
